import type { ItemRecord } from '../types';

export type LocationSection = { title: string; items: ItemRecord[] };

export function groupItemsByLocation(items: ItemRecord[]) {
  const groups = new Map<string, ItemRecord[]>();
  for (const item of items) {
    const title = item.locationGroup.trim() || item.locationNote.trim() || 'No location';
    const group = groups.get(title);
    if (group) group.push(item);
    else groups.set(title, [item]);
  }
  return [...groups.entries()].map(([title, sectionItems]) => ({
    title,
    items: sectionItems.toSorted((a, b) => b.createdAt.localeCompare(a.createdAt))
  })).toSorted((a, b) => {
    if (a.title === 'No location') return 1;
    if (b.title === 'No location') return -1;
    return a.title.localeCompare(b.title);
  });
}
